// src/components/frontpage/TownImage.jsx
// Simple full-sidebar-width town photo for the Locality sidebar.
// Takes a `src` prop from locality hero_image_url or falls back to a placeholder SVG.
// Shows `credit` attribution below the image when provided.

import React from 'react';
import { useTranslation } from '../../i18n/useTranslation';

// Inline placeholder — a blue-toned rectangle with a simple silhouette suggestion.
// Replace with a real photo at /images/frontpage/town-placeholder.webp when available.
const PLACEHOLDER = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 480 360' fill='none'%3E%3Crect width='480' height='360' fill='%23d4e4f7'/%3E%3Crect y='200' width='480' height='160' fill='%23b8d4f0'/%3E%3Crect x='60' y='160' width='80' height='100' rx='2' fill='%23a0c4e8'/%3E%3Crect x='200' y='120' width='100' height='140' rx='2' fill='%23a0c4e8'/%3E%3Crect x='340' y='170' width='70' height='90' rx='2' fill='%23a0c4e8'/%3E%3Crect x='230' y='90' width='10' height='30' fill='%2390b8e0'/%3E%3Ccircle cx='240' cy='300' r='30' fill='%2390b8e0' opacity='0.5'/%3E%3C/svg%3E";

const TownImage = ({ src, credit, compact = false, fullWidth = false }) => {
  const { t } = useTranslation('frontpage');
  const imageSrc = src || PLACEHOLDER;

  return (
    <div style={{ marginBottom: '12px' }}>
      <div style={{
        width: fullWidth ? '100%' : (compact ? '62%' : '100%'),
        maxWidth: fullWidth ? 'none' : (compact ? '400px' : 'none'),
        aspectRatio: compact ? '16 / 9' : '4 / 3',
        borderRadius: '8px',
        overflow: 'hidden'
      }}>
        <img
          src={imageSrc}
          alt={t('town_image_alt')}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block'
          }}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = PLACEHOLDER;
          }}
        />
      </div>
      {credit && (
        <div style={{
          fontFamily: 'OpenSauceSans, sans-serif',
          fontSize: '9px',
          color: '#6b7280',
          marginTop: '2px',
          lineHeight: '1.3'
        }}>
          {credit}
        </div>
      )}
    </div>
  );
};

export default TownImage;
